
/**
 * 알림 추가 데이터 (유형에 따라 다름)
 */
export type UpdateNotificationReadStatus200Data = { [key: string]: unknown };
